import type { CWReportOptions } from "@channelwill/report"

import appApi from "@/api/app"

/** 广告落地路由：官网广告链接先打到这里，SDK 写广告 Cookie 后跳转 listing */
export const CW_LISTING_LANDING_PATH = "/cw-listing-landing"

/** 本 App 的 Shopify Listing 地址 */
export const CW_LISTING_URL = "https://apps.shopify.com/parcelpanel"

/** cwreport.init 公共参数（落地页与主应用共用） */
export const getCWReportBaseOptions = (): CWReportOptions => ({
  // 自定义posthog key：根据需要将埋点上报到对应帐号上
  api_key: import.meta.env.VITE_CWREPORT_API_KEY,
  // 传入appId
  app_id: import.meta.env.VITE_CWREPORT_APP_ID,
  // 是否是测试服,默认为false,引用为测试cdn地址，设置为true，正式服为false
  test_mode: import.meta.env.VITE_CWREPORT_TEST_MODE === "true",
  // 是否开启gzip，默认为true,测试服建议为false，方便查看网络请求
  gzip: import.meta.env.VITE_CWREPORT_GZIP === "true",
  debug: false,
  // 广告落地时 SDK 写完 Cookie 后跳转的 listing 地址
  listing_url: CW_LISTING_URL,
})

export const isCWListingLandingPage = () => window.location.pathname === CW_LISTING_LANDING_PATH

/**
 * 广告落地页：不走授权与 userInfo，仅初始化 SDK，由 SDK 写广告 Cookie 并跳转 listing
 */
export const initCWListingLanding = () => {
  window.cwreport?.init(getCWReportBaseOptions())
}

/**
 * 安装归因：新用户且 Cookie 中有广告参数时，把广告属性交给后端写入安装记录
 */
export const submitAdProperties = () => {
  // 超管代登不计入归因（后端也会返回 403）
  if (window.isFromAdmin) {
    return
  }

  const ad = window.cwreport?.getAdProperties()

  if (!ad) {
    return
  }

  // 可选字段缺失时直接省略，由后端统一存为 ''
  appApi.saveAdProperties(ad).catch((e: unknown) => {
    console.error("saveAdProperties failed", e)
  })
}
